import { apiRequest, serviceCreate } from "../../../../services/adapters/base";

class CreateRepository {
  fetchCreate = async (query) => {
    return await apiRequest(
      "post",
      serviceCreate,
      {
        body: query,
      },
      true
    );
  };
}

export default CreateRepository;
